module.exports = "/_next/static/images/ec20a17c149021cf83949f561dfa28ac-doc-success.svg.webp";